import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import couterpart from 'counterpart';
import DatePicker from 'react-datepicker';
import { ToastsContainer, ToastsStore } from 'react-toasts';
import Spinner from 'react-spinner-material';

import Dialog from 'react-bootstrap-dialog';
import { Multiselect } from 'multiselect-react-dropdown';

import "react-table/react-table.css";
import "../css/style.css";

import { SIMPLE_PLAN_NUMOFDAY, WO_BONG, WO_CANCELLED, WO_KIEMTRA, WO_PRINT_TAIL, WO_QUAYKIM, WO_SHIP_FROMAU, WO_SHIP_FROMUS, WO_SHIP_FROMVN, WO_VOBAO, WO_WAIT_FOR_INFO, WO_XI } from '../constants';
import MenuComponent2 from './MenuComponent2';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import WorkOrderDataService from '../services/WorkOrderDataService';
import MasterDataService from '../services/MasterDataService';
import AuthenticationService from '../services/AuthenticationService';
import UserDataService from '../services/UserDataService';
import { ICON_COLOR } from '../icon';
import queryString from 'query-string'

import { FaEdit, FaFilter, FaSave } from 'react-icons/fa';
import { Buffer } from 'buffer';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';


class PlanningSimple extends Component {
  constructor() {
    super();

    const numOfMonths = 24;
    var fromDate = new Date(new Date().getTime() - numOfMonths * 30 * 24 * 60 * 60 * 1000 * 3);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    var toDate = new Date();
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);

    this.state = {
      currentDay: 0,
      donHomNay: 0,
      donPhatSinh: 0,
      donNgayMai: 0,
      soNgayCanLV: 0,
      soNgayCanLVDD: 0,
      capacityByDayOfWeek: {},
      capacityByWorker: {},
      capacityOfWorkers: {},
      masterCapacityOfWorkers: {},
      daysofweek: [],
      masterDaysofweek: [2,3,4,5,6,7,8],
      soNgayCanLVInfo: {},
      soNgayTCInfo: {},
      soMonTCInfo: {},
      soMonDaLam: {},
      workers: [],
      spinnerVisible: false,
      allStatus: [],
      fromDate: fromDate,
      toDate: toDate,
      selectAll: 0,
      show: false,
      selectedWoStatusList: []
    };
  }

  encodeBase64(data) {
    return Buffer.from(data).toString('base64');
  }

  decodeBase64(data) {
    return Buffer.from(data, 'base64').toString('ascii');
  }

  getDate(){
    let today = new Date().toISOString().slice(0, 10);
    return today;
  }

  getCurrentDayOfWeek(){
    var date = new Date();
    let currentDay = date.getDay();
    currentDay = currentDay === 0? 8 : currentDay + 1;
    return currentDay;
  }

  getDateBy(idx){
    const today = new Date();
    const nextThreeDays = new Date(today.setDate(today.getDate() + idx));
    return nextThreeDays.toISOString().slice(0, 10);
  }

  clearSearchInfo() {
    sessionStorage.removeItem("plansimple.fromDate")
    sessionStorage.removeItem("plansimple.toDate")
    sessionStorage.removeItem("plansimple.selectedWoStatusList");
  }
  saveSearchInfo(fromDate, toDate, selectedWoStatusList) {
    sessionStorage.setItem("plansimple.fromDate", fromDate);
    sessionStorage.setItem("plansimple.toDate", toDate);
    sessionStorage.setItem("plansimple.selectedWoStatusList", JSON.stringify(selectedWoStatusList));
  }

  componentDidMount() {
    MasterDataService.retrieveAllStatus().then(data => {
      let statusList = [];

      if (data !== undefined && data !== null) {
        statusList.push({
          id: 0,
          name: 'All'
        });
        for (let i = 0; i < data.length; i++) {
          if (data[i].type !== 2) {
            continue;
          }

          if (data[i].status === WO_WAIT_FOR_INFO || data[i].status === WO_PRINT_TAIL 
            || data[i].status === WO_BONG 
            || data[i].status === WO_QUAYKIM
            || data[i].status === WO_XI
            || data[i].status === WO_VOBAO
            || data[i].status === WO_SHIP_FROMVN || data[i].status === WO_SHIP_FROMUS || data[i].status === WO_SHIP_FROMAU
            || data[i].status === WO_CANCELLED || data[i].status === WO_KIEMTRA){
              continue;
            }

          statusList.push({
            id: data[i].status,
            name: data[i].statusDescVn
          });
        }
      }    

      WorkOrderDataService.getLatestSimplePlan().then(data => {
        console.log("LATEST PLAN: ", data);
        let info = JSON.parse(data.content);
        let numOfDay = SIMPLE_PLAN_NUMOFDAY;
        let donPhatSinh = 0;
        let deadlineSx = 3;

        if (info !== undefined && info.numOfDay !== undefined){
          numOfDay = info.numOfDay; 
          donPhatSinh = info.donPhatSinh;
          deadlineSx = info.deadlineSx;
        }
        this.setState({ allStatus: data, statusList: statusList, savedPlan: info, numOfDay: numOfDay, donPhatSinh: donPhatSinh, deadlineSx: deadlineSx }, () => {
          let fromDate = this.getItem("plansimple.fromDate")
          let toDate = this.getItem("plansimple.toDate")

          const values = queryString.parse(this.props.location.search);
          let numOfMonths = 1;
          if (values !== undefined && values.status !== undefined) {
            numOfMonths = 24;
          }

          let woStatusList = [];
          let swoStatusList = WorkOrderUtil.getItem('plansimple.selectedWoStatusList');
          if (swoStatusList !== undefined){
            try {
              woStatusList = JSON.parse(swoStatusList)
            } catch (ec) {

            }
          } else {
            woStatusList = this.state.statusList;
          }

          if (values === undefined || (values.status === undefined && values.isback === undefined) || fromDate === null || fromDate === undefined) {
            let backTime = 12 * 30 * 24 * 60 * 60 * 1000 * numOfMonths;
            fromDate = new Date(new Date().getTime() - backTime);//12 month
            fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
          }

          if (toDate === null || toDate === undefined) {
            toDate = new Date();
            toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
          }

          this.setState({
            fromDate: fromDate,
            toDate: toDate,
            selectedWoStatusList: woStatusList,
          }, () => {
            const query = queryString.parse(this.props.location.search);
            if (query.caller !== '0') { //Clicked on NAV
              this.filterWorkOrdersBy(false);
            }
          });
        })
      });
    });
  }

  toggleRow(id) {
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[id] = !this.state.selected[id];
    this.setState({
      selected: newSelected,
      selectAll: 2
    });
  }

  getItem(key) {
    let value = sessionStorage.getItem(key);
    return value === null || value === '' || value === 'null' ? undefined : value
  }
  saveItem(key, value) {
    if (value !== undefined && value !== 'null' && value !== '') {
      sessionStorage.setItem(key, value);
    }
  }

  onFilter() {
    this.clearSearchInfo();
    this.filterWorkOrdersBy(true);
  }

  plan(onlyRecalculate){
    let currentDay = this.getCurrentDayOfWeek();
    this.setState({currentDay: currentDay}, () =>{
      let daysofweek = this.initDaysOfWeek(this.state.numOfDay - 1);
      this.setState({ daysofweek: daysofweek}, () => {
        this.loadWorkers(onlyRecalculate, false);
      });
    });
  }

  filterWorkOrdersBy(onlyRecalculate) {
    var fromDate = this.state.fromDate;
    var toDate = this.state.toDate;
    let selectedWoStatusList = this.state.selectedWoStatusList ? this.state.selectedWoStatusList : []
    let includeMau = this.state.includeMau;

    try {
      let selectedWoStatusCodes = [];
      if (selectedWoStatusList) {
        for (let i = 0; i < selectedWoStatusList.length; i++) {
          selectedWoStatusCodes.push(selectedWoStatusList[i].id);
        }
      }

      let info = {
        fromDate: fromDate,
        toDate: toDate,
        woStatusList: selectedWoStatusCodes,
        includeMau: includeMau,
      };

      this.setState({ spinnerVisible: true }, () => {
        this.setState({ donHomNay: 0 }, () => {
          WorkOrderDataService.countWorkOrdersBy(info)
            .then(data => {
              this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
              //console.log("COUNT WORKORDER BY", data);
              this.saveSearchInfo(fromDate, toDate, selectedWoStatusList);
              this.setState({ donHomNay : data.count, don24: data.dailyCount, donDauNgay: data.beginCount }, () => {
                this.plan(onlyRecalculate);
              })
            });
        });
      });
    } catch (e) {
      this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
    }
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  getStatusDescription(status) {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return status;
    }
    let istatus = parseInt(status);
    let statusInfo = this.state.allStatus.find(x => {
      return x.status === istatus;
    });
    if (statusInfo !== undefined) {
      return statusInfo.statusDescVn;
    }
    return status;
  }

  handleFromDateChange(date) {
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      fromDate: sDate
    });
  }

  handleToDateChange(date) {
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      toDate: sDate
    });
  }

  handleSelectAllClick() {
    if (this.state.selectAll === '1') {
      this.setState({ selectAll: '0', selectedWoStatusList: [], woSubStatus: undefined });
    } else {
      let allStattus = this.state.statusList;
      this.setState({ selectAll: '1', selectedWoStatusList: allStattus, woSubStatus: undefined });
    }
  }

  onStatusSelect(selectedList, selectedItem) {
    if (selectedItem.id === 0) {
      this.handleSelectAllClick()
      return;
    }
    this.setState({
      selectedWoStatusList: selectedList
    });
  }

  onStatusRemove(selectedList, removedItem) {
    if (removedItem.id === 0) {
      this.handleSelectAllClick()
      return;
    }
    this.setState({
      selectedWoStatusList: selectedList
    });
  }

  getCapacityBy(worker, dayOfWeek){
    if (dayOfWeek === 2){
      return worker.thuHai;
    }

    if (dayOfWeek === 3){
      return worker.thuBa;
    }

    if (dayOfWeek === 4){
      return worker.thuTu;
    }

    if (dayOfWeek === 5){
      return worker.thuNam;
    }

    if (dayOfWeek === 6){
      return worker.thuSau;
    }

    if (dayOfWeek === 7){
      return worker.thuBay;
    }

    if (dayOfWeek === 8){
      return worker.thuTam;
    }

    return 0;
  }

  loadWorkers(onlyRecalculate, isReset) {
    if (onlyRecalculate) {
      this.calculateCapacityByDaysOfWeek();
      this.calculateCapacityByWorkers();
      return;
    }

    if (AuthenticationService.isAdmin()) {
      this.setState({ workers: [], capacityOfWorkers: {}}, () => {
        if (isReset){
          this.reloadCapacity(undefined);
        } else {
          this.reloadCapacity(this.state.savedPlan);
        }
      });
    }
  }

  parseIntIgnoreNaN(vl){
    if (vl === undefined || vl === null || vl === "" || isNaN(vl)){
      return 0;
    }
    return parseInt(vl);
  }

  loadWorkerCapacities(){
    UserDataService.retrieveWorkersWithCapacity().then(data => {
      let capacityOfWorkers = {};
      let numDays = this.state.masterDaysofweek.length;
      let len = data === undefined || data === null? 0 : data.length;
      for (let i = 0; i < len; i++) {
        let initCapacity = {};
        let userName = data[i].userName;
        for(let j=0; j<numDays; j++){
          let dayOfWeek = this.state.masterDaysofweek[j];
          let capacity = this.getCapacityBy(data[i], dayOfWeek);
          initCapacity[dayOfWeek] = capacity;
        }

        capacityOfWorkers[userName] = {
          "initCapacity": initCapacity
        };
      }

      this.setState({ masterCapacityOfWorkers: capacityOfWorkers, show: true}, () => {
         //console.log(capacityOfWorkers);
      });
    });
  }

  reloadCapacity(info){
    UserDataService.retrieveWorkersWithCapacity().then(data => {
      let capacityOfWorkers = {};
      let len = data.length;
      let workers = [];
      
      if (info === undefined || info.capacityOfWorkers == undefined){
        //console.log(numDaysOfPlan);
        let numDaysOfPlan = this.state.daysofweek.length;

        for (let i = 0; i < len; i++) {
          let userName = data[i].userName;
          workers.push({ key: data[i].id, label: data[i].firstName + data[i].lastName, value: data[i].id, userName: userName });

          let initCapacity = {};
          let dcCapacity = {};
          let realCapacity = {};
          for(let j=0; j<numDaysOfPlan; j++){
            let dayOfWeek = this.state.daysofweek[j];
            let capacity = this.getCapacityBy(data[i], dayOfWeek);
            initCapacity[dayOfWeek + "_" + j] = capacity;
            dcCapacity[dayOfWeek + ""] = 0;
            realCapacity[dayOfWeek + "_" + j] = capacity;
          }
          capacityOfWorkers[userName] = {
            "initCapacity": initCapacity,
            "dcCapacity": dcCapacity,
            "realCapacity": realCapacity,
          };
        }

        this.setState({workers: workers, capacityOfWorkers: capacityOfWorkers}, () => {
          this.calculateCapacityByDaysOfWeek();
          this.calculateCapacityByWorkers();
        });

      } else {
        let daysofweek = this.initDaysOfWeek(this.state.numOfDay - 1);
        this.setState({daysofweek: daysofweek}, () => {
          let numDaysOfPlan = this.state.daysofweek.length;
          for (let i = 0; i < len; i++) {
            let userName = data[i].userName;
            workers.push({ key: data[i].id, label: data[i].firstName + data[i].lastName, value: data[i].id, userName: userName });

            let initCapacity = {};
            let dcCapacity = {};
            let realCapacity = {};
            let latestCapacityOfWorkers = info.capacityOfWorkers;

            let userCapacity = latestCapacityOfWorkers[userName];
            if (userCapacity === undefined){
              for(let j=0; j<numDaysOfPlan; j++){
                let dayOfWeek = this.state.daysofweek[j];
                let capacity = this.getCapacityBy(data[i], dayOfWeek);
                let dayOfWeekOnyIdx = dayOfWeek + ""; 
                initCapacity[dayOfWeek + "_" + j] = capacity;
                dcCapacity[dayOfWeekOnyIdx] = 0;
                realCapacity[dayOfWeek + "_" + j] = capacity;
              }
              capacityOfWorkers[userName] = {
                "initCapacity": initCapacity,
                "dcCapacity": dcCapacity,
                "realCapacity": realCapacity,
              };
            } else {
              for(let j=0; j<numDaysOfPlan; j++){
                let dayOfWeek = this.state.daysofweek[j];
                let dayOfWeekIdx = dayOfWeek + "_" + j; 
                let dayOfWeekOnyIdx = dayOfWeek + ""; 
                let capacity = this.getCapacityBy(data[i], dayOfWeek);
                initCapacity[dayOfWeekIdx] = capacity;
                dcCapacity[dayOfWeekOnyIdx] = userCapacity.dcCapacity[dayOfWeekOnyIdx] === undefined? 0: userCapacity.dcCapacity[dayOfWeekOnyIdx];
                realCapacity[dayOfWeekIdx] = this.parseIntIgnoreNaN(initCapacity[dayOfWeekIdx]) + this.parseIntIgnoreNaN(dcCapacity[dayOfWeekOnyIdx]);
              }

              capacityOfWorkers[userName] = {
                "initCapacity": initCapacity,
                "dcCapacity": dcCapacity,
                "realCapacity": realCapacity
              };
            }
          }
        });

        this.setState({workers: workers, capacityOfWorkers: capacityOfWorkers}, () => {
          this.calculateCapacityByDaysOfWeek();
          this.calculateCapacityByWorkers();
        });
        
      }
    });
  }

  calculateAfterDc(userName, dayOfWeek, idx){
    let capacityOfWorkers = this.state.capacityOfWorkers;
    if (capacityOfWorkers === undefined || capacityOfWorkers === null){
      return;
    }

    const keys = Object.keys(capacityOfWorkers);
    for (let i = 0; i < keys.length; i++) {
      let key = keys[i];
      if (userName !== key){
        continue;
      }
      let initByDay = parseInt(capacityOfWorkers[key]["initCapacity"][dayOfWeek + "_" + idx]);
      let dcByDay = parseInt(capacityOfWorkers[key]["dcCapacity"][dayOfWeek + ""]);
      let realByDay = initByDay + dcByDay;

      capacityOfWorkers[key]["realCapacity"][dayOfWeek + "_" + idx] = realByDay;
    }

    this.setState({ capacityOfWorkers: capacityOfWorkers }, () => {
      this.calculateCapacityByDaysOfWeek();
      this.calculateCapacityByWorkers();
    });
  }

  getCapacityByDayOfWeek(dayOfWeek, keyType, idx){
    let capacityByDayOfWeekKey = dayOfWeek + "_" + idx;
    if (this.state.capacityByDayOfWeek[capacityByDayOfWeekKey] === undefined){
      return "";
    }

    if (this.state.capacityByDayOfWeek[capacityByDayOfWeekKey][keyType] === undefined){
      return "";
    }

    return this.state.capacityByDayOfWeek[capacityByDayOfWeekKey][keyType] + "";
  }

  getCapacityByWorker(userName, keyType){
    if (this.state.capacityByWorker[userName] === undefined){
      return "";
    }

    if (this.state.capacityByWorker[userName][keyType] === undefined){
      return "";
    }

    return this.state.capacityByWorker[userName][keyType] + "";
  }

  calculateCapacityByDaysOfWeek(){
    let capacityByDayOfWeek = {};
    for(let i=0; i< this.state.daysofweek.length; i++){
      let dayOfWeekKey = "" + this.state.daysofweek[i];
      let capacityByDayOfWeekKey = dayOfWeekKey + "_" + i;
      //console.log("capacityByDayOfWeekKey: " + capacityByDayOfWeekKey);

      capacityByDayOfWeek[capacityByDayOfWeekKey] = this.calculateCapacityByDayOfWeek(dayOfWeekKey, i);
    }

    // console.log(capacityByDayOfWeek);
    this.setState({capacityByDayOfWeek: capacityByDayOfWeek}, () => {
      let soNgayCanLVInfo = this.state.soNgayCanLVInfo;
      let soNgayTCInfo = this.state.soNgayTCInfo;
      let soMonTCInfo = this.state.soMonTCInfo;
      let soMonDaLam = this.state.soMonDaLam;
      let somonDaLamHienTai = 0;

      for(let i=0; i< this.state.daysofweek.length; i++){
        let dayOfWeek = this.state.daysofweek[i];
        let soNgaycanLV = 0;
        let songayTangca = 0;
        let somonTangca = 0;
        let workedCapacity = 0;
        if (i == 0){
          let homnayEffortEstimation = parseInt(this.getCapacityByDayOfWeek(dayOfWeek, "realCapacityByDay", i));
          if (homnayEffortEstimation === 0){
            continue;
          }
          workedCapacity = homnayEffortEstimation;

          let wh = this.getWorkedHours();
          somonDaLamHienTai = wh * (workedCapacity/8);

          soNgaycanLV = this.state.donHomNay / homnayEffortEstimation;
          songayTangca = soNgaycanLV - this.state.deadlineSx;
          if (songayTangca < 0 && homnayEffortEstimation < 0){ 
            somonTangca = songayTangca * homnayEffortEstimation;
            somonTangca = 0 - somonTangca;
          } else {
             somonTangca = songayTangca * homnayEffortEstimation;
          }
        } else {
          let soNgayTruocDo = 0; 
          for(let j=0; j<i; j++){
            if (j === 0){
              continue;
            }
            let preDayOfWeek = this.state.daysofweek[j];
            soNgayTruocDo += parseInt(this.getCapacityByDayOfWeek(preDayOfWeek, "realCapacityByDay", j));
          }

          let homnayEffortEstimation = parseInt(this.getCapacityByDayOfWeek(this.state.daysofweek[i], "realCapacityByDay", i));
          if (homnayEffortEstimation === 0){
            continue;
          }
          
          let donNgayMai = this.state.donHomNay + this.state.donPhatSinh;
          console.log("donNgayMai: " + donNgayMai + ", soNgayTruocDo: " + soNgayTruocDo + ", somonDaLamHienTai: " + somonDaLamHienTai + ", homnayEffortEstimation: "  + homnayEffortEstimation);
          soNgaycanLV = (donNgayMai - soNgayTruocDo - somonDaLamHienTai) / homnayEffortEstimation;
          songayTangca = soNgaycanLV - this.state.deadlineSx;
          if (songayTangca < 0 && homnayEffortEstimation < 0){ 
            somonTangca = songayTangca * homnayEffortEstimation;
            somonTangca = 0 - somonTangca;
          } else {
             somonTangca = songayTangca * homnayEffortEstimation;
          }
        }
        soNgayCanLVInfo[dayOfWeek + "_" + i] = soNgaycanLV;
        soNgayTCInfo[dayOfWeek + "_" + i] = songayTangca;
        soMonTCInfo[dayOfWeek + "_" + i] = somonTangca;
        soMonDaLam[dayOfWeek + "_" + i] = this.getWorkedHours() * (workedCapacity/8);
      }

      //console.log("soNgayCanLVInfo: ", soNgayCanLVInfo);

      this.setState({ soNgayCanLVInfo : soNgayCanLVInfo, soNgayTCInfo: soNgayTCInfo, soMonTCInfo: soMonTCInfo, soMonDaLam: soMonDaLam });
    });
  }

  calculateCapacityByWorkers(){
    let capacityByWorker = {};

    let workers = this.state.workers;
    if (workers === undefined || workers.length  <=0){
      return;
    }
    for (let i = 0; i < workers.length; i++) {
      let worker = workers[i];
      capacityByWorker[worker.userName] = this.calculateCapacityByWorker(worker.userName);
    }
    this.setState({capacityByWorker: capacityByWorker}, () =>{
      this.recalculate();
    });
  }

  recalculate(){
    let donNgayMai = this.state.donHomNay + this.state.donPhatSinh;

    let soNgaycanLV = this.state.donHomNay / this.getCapacityByDayOfWeek(this.state.currentDay, "realCapacityByDay", 0);

    let homnayEffortEstimation  =this.getCapacityByDayOfWeek(this.state.currentDay, "realCapacityByDay", 0);
    let ngayMaiEffortEstimation = this.getCapacityByDayOfWeek(this.getNextDay(this.state.currentDay), "realCapacityByDay", 1);
    let soNgayCanLVDD = (donNgayMai - homnayEffortEstimation) / ngayMaiEffortEstimation;

    let tangcaHomnay = "";
    if (soNgaycanLV - this.state.deadlineSx > 0){
      tangcaHomnay = "Tăng ca";
    } else {
      tangcaHomnay = "Không tăng ca";
    }

    let tangcaNgaymai = "";
    if (soNgayCanLVDD - this.state.deadlineSx > 0){
      tangcaNgaymai = "Tăng ca";
    } else {
      tangcaNgaymai = "Không tăng ca";
    }

    let songayTangca = soNgayCanLVDD - this.state.deadlineSx;
    let somonTangca = songayTangca * homnayEffortEstimation;
    this.setState({
      donNgayMai: donNgayMai, 
      soNgaycanLV: soNgaycanLV, 
      soNgayCanLVDD: soNgayCanLVDD, 
      tangcaHomnay: tangcaHomnay, 
      tangcaNgaymai: tangcaNgaymai,
      songayTangca: songayTangca,
      somonTangca: somonTangca
    })
  }

  getNextDay(currentDay){
    if (currentDay === 8){ // Chu nhat
      return 2;// thu 2
    } else {
      return currentDay + 1;
    }
  }

  getCurrentHour(){
    const now = new Date();
    const hours = now.getHours() + now.getMinutes()/60;
    return hours;
  }

  getNumOfWorkedHours(){
    return this.getWorkedHours();
  }

  getWorkedHours(){
    if (this.getCurrentHour() >= 13 && this.getCapacityBy <= 17){
      return this.getCurrentHour() - 9;// Start woring at 8 am
    } else if (this.getCurrentHour() > 17){
      let homnaycapcityInit = parseInt(this.getCapacityByDayOfWeek(this.state.currentDay, "initCapacityByDay", 0));
      let homnayEffortEstimation = parseInt(this.getCapacityByDayOfWeek(this.state.currentDay, "realCapacityByDay", 0));
      if (homnaycapcityInit === homnayEffortEstimation){
        return 8;
      } else {
        let h = this.getCurrentHour() - 9 - 0.5;
        console.log(this.getCurrentHour(), h);
        return h;
      }
    }
    return this.getCurrentHour() - 8;// Start woring at 8 am
  }


  calculateCapacityByDayOfWeek(dayOfWeekKey, idx){
    let initCapacityByDay = 0;
    let dcCapacityByDay = 0;
    let realCapacityByDay = 0;
    let donNgayMai = 0

    donNgayMai = this.state.donHomNay + this.state.donPhatSinh;

    let ret = {
      "initCapacityByDay": initCapacityByDay,
      "dcCapacityByDay": dcCapacityByDay,
      "realCapacityByDay": realCapacityByDay,
      "donNgayMai": donNgayMai
    };

    let capacityOfWorkers = this.state.capacityOfWorkers;
    if (capacityOfWorkers === undefined || capacityOfWorkers === null){
      return ret;
    }

    const keys = Object.keys(capacityOfWorkers);
    if (keys === undefined || keys.length  <=0){
      return ret;
    }

    // console.log("CAPACITY OF WORKERS: ", capacityOfWorkers);

    for(let d=0; d<this.state.daysofweek.length; d++){
      if (idx !== d) {
        continue;
      }

      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        
        let initValue = capacityOfWorkers[key]["initCapacity"][dayOfWeekKey + "_" + d];
        let dcValue = capacityOfWorkers[key]["dcCapacity"][dayOfWeekKey + ""];
        let realValue = capacityOfWorkers[key]["realCapacity"][dayOfWeekKey + "_" + d];

        initCapacityByDay += parseInt(initValue === undefined || isNaN(initValue)? 0: initValue);
        dcCapacityByDay += parseInt(dcValue === undefined || isNaN(dcValue)? 0: dcValue);
        realCapacityByDay += parseInt(realValue === undefined || isNaN(realValue)? 0: realValue);
      }
    }

    ret = {
      "initCapacityByDay": initCapacityByDay,
      "dcCapacityByDay": dcCapacityByDay,
      "realCapacityByDay": realCapacityByDay,
      "donNgayMai": donNgayMai
    };
    //console.log("calculateCapacityByDayOfWeek: ", ret);
    return ret;
  }

  calculateCapacityByWorker(userName){
    let initCapacityByWorker = 0;
    let dcCapacityByWorker = 0;
    let realCapacityByWorker = 0;

    let ret = {
      "initCapacityByWorker": initCapacityByWorker,
      "dcCapacityByWorker": dcCapacityByWorker,
      "realCapacityByWorker": realCapacityByWorker
    };

    if (userName === undefined){
      return ret;
    }

    let capacityOfWorkers = this.state.capacityOfWorkers;
    if (capacityOfWorkers === undefined || capacityOfWorkers === null){
      return ret;
    }
    
    for(let d=0; d<this.state.daysofweek.length; d++){
      let dayOfWeekKey = this.state.daysofweek[d];
      let initValue = capacityOfWorkers[userName]["initCapacity"][dayOfWeekKey + "_" + d];
      let dcValue = capacityOfWorkers[userName]["dcCapacity"][dayOfWeekKey + ""];
      let realValue = capacityOfWorkers[userName]["realCapacity"][dayOfWeekKey + "_" + d];

      initCapacityByWorker += parseInt(isNaN(initValue)? 0: initValue);
      dcCapacityByWorker += parseInt(isNaN(dcValue)? 0: dcValue);
      realCapacityByWorker += parseInt(isNaN(realValue)? 0: realValue);
    }

    ret = {
      "initCapacityByWorker": initCapacityByWorker,
      "dcCapacityByWorker": dcCapacityByWorker,
      "realCapacityByWorker": realCapacityByWorker
    };
    //console.log(ret);
    return ret;
  }

  handleCapacityDcChange(userName, dayOfWeek, idx, e){
    var name = e.target.name;
    if (name === undefined){
        return;
    }

    var value = e.target.value;
    if (value === undefined || isNaN(value) || value === null || value === ""){
        return;
    }

    let capacityOfWorkers = this.state.capacityOfWorkers;
    capacityOfWorkers[userName]["dcCapacity"][dayOfWeek + ""] = value;
    this.setState({ capacityOfWorkers:  capacityOfWorkers}, () => {
      this.calculateAfterDc(userName, dayOfWeek, idx);
    });
  }


  emptyIfNaN(vl){
    return isNaN(vl)? "" : vl;
  }

  renderDayOfWeek(worker, dayOfWeek, idx){
    return (
      <>
        <td>
          <input name={worker.userName + "_es_" + dayOfWeek} id={worker.userName + "_es_" + dayOfWeek} 
              type="text" size="5" style={{ textAlign: "right", width: '100%'}} placeholder="" 
              defaultValue={this.state.capacityOfWorkers[worker.userName]["initCapacity"][dayOfWeek + "_" + idx]} readOnly/>
        </td>
        <td>
          <input name={worker.userName + "_ot_" + dayOfWeek} id={worker.userName + "_ot_" + dayOfWeek } className= "fixlen" 
              type="text" size="5" style={{ textAlign: "right", width: '100%'}} placeholder=""
              defaultValue={this.state.capacityOfWorkers[worker.userName]["dcCapacity"][dayOfWeek + ""]} 
              onChange={this.handleCapacityDcChange.bind(this, worker.userName, dayOfWeek, idx)}/>
        </td>
        <td>
          <label className='fixlen' style={{ marginTop: "5px" }}>{ this.emptyIfNaN(this.state.capacityOfWorkers[worker.userName]["realCapacity"][dayOfWeek + "_" + idx]) }</label>
        </td>
      </>
    );
  }

  getSoMonDaLam(dayOfWeek, idx){
    if (this.state.daysofweek[0] === dayOfWeek){
      return this.toFix(this.state.soMonDaLam[dayOfWeek + "_" + idx]);
    }
    return 0;
  }

  getDayOfWeekDescription(d, idx){
    if (d === 8){
      return "Chủ nhật";
    }
    return "Thứ " + d;
  }

  renderDayOfWeekHeader(dayOfWeek, idx){
    let dateString = this.getDateBy(idx);
    if (dayOfWeek === 2){
      return (
        <th style={{ background:"purple", textAlign:"center"}} colSpan="3" id={"dayOfWeek_" + dayOfWeek + "_" + idx}  key={"dayOfWeek_" + dayOfWeek + "_" + idx}>
            <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
            <br/><label>({ dateString })</label>
        </th>
      );
    } 

    if (dayOfWeek === 3){
      return (
        <th style={{ background:"gray", textAlign:"center"}} colSpan="3" id={"dayOfWeek_" + dayOfWeek + "_" + idx}  key={"dayOfWeek_" + dayOfWeek + "_" + idx}>
            <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
            <br/><label>({ dateString })</label>
        </th>
      );
    } 

    if (dayOfWeek === 4){
      return (
        <th style={{ background:"cyan", textAlign:"center"}} colSpan="3" id={"dayOfWeek_" + dayOfWeek + "_" + idx}  key={"dayOfWeek_" + dayOfWeek + "_" + idx}>
            <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
            <br/><label>({ dateString })</label>
        </th>
      );
    } 

    if (dayOfWeek === 5){
      return (
        <th style={{ background:"green", textAlign:"center"}} colSpan="3" id={"dayOfWeek_" + dayOfWeek + "_" + idx}  key={"dayOfWeek_" + dayOfWeek + "_" + idx}>
            <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
            <br/><label>({ dateString })</label>
        </th>
      );
    } 

    if (dayOfWeek === 6){
      return (
        <th style={{ background:"yellow", textAlign:"center"}} colSpan="3" id={"dayOfWeek_" + dayOfWeek + "_" + idx}  key={"dayOfWeek_" + dayOfWeek + "_" + idx}>
            <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
            <br/><label>({ dateString })</label>
        </th>
      );
    } 

    if (dayOfWeek === 7){
      return (
        <th style={{ background:"orange", textAlign:"center"}} colSpan="3" id={"dayOfWeek_" + dayOfWeek + "_" + idx}  key={"dayOfWeek_" + dayOfWeek + "_" + idx}>
            <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
            <br/><label>({ dateString })</label>
        </th>
      );
    } 

    if (dayOfWeek === 8){
      return (
        <th style={{ background:"pink", textAlign:"center"}} colSpan="3" id={"dayOfWeek_" + dayOfWeek + "_" + idx}  key={"dayOfWeek_" + dayOfWeek + "_" + idx}>
            <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
            <br/><label>({ dateString })</label>
        </th>
      );
    } 
    
    return (
      <th style={{ background:"white", textAlign:"center"}} colSpan="3" id={"dayOfWeek_" + dayOfWeek + "_" + idx}  key={"dayOfWeek_" + dayOfWeek + "_" + idx}>
          <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
          <br/><label>({ dateString })</label>
      </th>
    );
  }

  renderMasterDayOfWeekHeader(dayOfWeek, idx){
    if (dayOfWeek === 2){
      return (
        <th style={{ background:"purple", textAlign:"center"}} id={"masterDayOfWeek_" + dayOfWeek + "_" + idx}  key={"masterDayOfWeek_" + dayOfWeek + "_" + idx}>
            <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
        </th>
      );
    } 

    if (dayOfWeek === 3){
      return (
        <th style={{ background:"gray", textAlign:"center"}} id={"masterDayOfWeek_" + dayOfWeek + "_" + idx}  key={"masterDayOfWeek_" + dayOfWeek + "_" + idx}>
            <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
        </th>
      );
    } 

    if (dayOfWeek === 4){
      return (
        <th style={{ background:"cyan", textAlign:"center"}} id={"masterDayOfWeek_" + dayOfWeek + "_" + idx}  key={"masterDayOfWeek_" + dayOfWeek + "_" + idx}>
            <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
        </th>
      );
    } 

    if (dayOfWeek === 5){
      return (
        <th style={{ background:"green", textAlign:"center"}} id={"masterDayOfWeek_" + dayOfWeek + "_" + idx}  key={"masterDayOfWeek_" + dayOfWeek + "_" + idx}>
            <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
        </th>
      );
    } 

    if (dayOfWeek === 6){
      return (
        <th style={{ background:"yellow", textAlign:"center"}} id={"masterDayOfWeek_" + dayOfWeek + "_" + idx}  key={"masterDayOfWeek_" + dayOfWeek + "_" + idx}>
            <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
        </th>
      );
    } 

    if (dayOfWeek === 7){
      return (
        <th style={{ background:"orange", textAlign:"center"}} id={"masterDayOfWeek_" + dayOfWeek + "_" + idx}  key={"masterDayOfWeek_" + dayOfWeek + "_" + idx}>
            <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
        </th>
      );
    } 

    if (dayOfWeek === 8){
      return (
        <th style={{ background:"pink", textAlign:"center"}} id={"masterDayOfWeek_" + dayOfWeek + "_" + idx}  key={"masterDayOfWeek_" + dayOfWeek + "_" + idx}>
            <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
        </th>
      );
    } 
    
    return (
      <th style={{ background:"white", textAlign:"center"}} id={"masterDayOfWeek_" + dayOfWeek + "_" + idx}  key={"masterDayOfWeek_" + dayOfWeek + "_" + idx}>
          <label>{ this.getDayOfWeekDescription(dayOfWeek, idx) }</label>
      </th>
    );
  }

  getTC(vl){
    let className = "";
    if (vl > 0){
      className = "fixlenTC";
    }
    return className;
  }

  renderWorkDayInfoHeader(dayOfWeek, idx){
    if (dayOfWeek === 2){
      return (
        <>
          <th style={{ background:"purple", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "1_" + idx}  key={"workdayinfo_" + dayOfWeek + "1_" + idx}>
              <label>Số ngày cần LV</label>
              <br/> <label>{ this.toFix(this.state.soNgayCanLVInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"purple", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "2_" + idx}  key={"workdayinfo_" + dayOfWeek + "2_" + idx}>
              <label>Số ngày TC</label>
              <br/> <label className={ this.getTC(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"purple", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "3_" + idx}  key={"workdayinfo_" + dayOfWeek + "3_" + idx}>
              <label>Số món TC</label>
              <br/> <label className={ this.getTC(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
        </>    
      );
    } 

    if (dayOfWeek === 3){
      return (
        <>
          <th style={{ background:"gray", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "1_" + idx}  key={"workdayinfo_" + dayOfWeek + "1_" + idx}>
              <label>Số ngày cần LV</label>
              <br/> <label>{ this.toFix(this.state.soNgayCanLVInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"gray", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "2_" + idx}  key={"workdayinfo_" + dayOfWeek + "2_" + idx}>
              <label>Số ngày TC</label>
              <br/> <label className={ this.getTC(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"gray", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "3_" + idx}  key={"workdayinfo_" + dayOfWeek + "3_" + idx}>
              <label>Số món TC</label>
              <br/> <label className={ this.getTC(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
        </>
      );
    } 

    if (dayOfWeek === 4){
      return (
        <>
          <th style={{ background:"cyan", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "1_" + idx}  key={"workdayinfo_" + dayOfWeek + "1_" + idx}>
              <label>Số ngày cần LV</label>
              <br/> <label>{ this.toFix(this.state.soNgayCanLVInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"cyan", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "2_" + idx}  key={"workdayinfo_" + dayOfWeek + "2_" + idx}>
              <label>Số ngày TC</label>
              <br/> <label className={ this.getTC(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"cyan", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "3_" + idx}  key={"workdayinfo_" + dayOfWeek + "3_" + idx}>
              <label>Số món TC</label>
              <br/> <label className={ this.getTC(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
        </>
      );
    } 

    if (dayOfWeek === 5){
      return (
        <>
          <th style={{ background:"green", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "1_" + idx}  key={"workdayinfo_" + dayOfWeek + "1_" + idx}>
              <label>Số ngày cần LV</label>
              <br/> <label>{ this.toFix(this.state.soNgayCanLVInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"green", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "2_" + idx}  key={"workdayinfo_" + dayOfWeek + "2_" + idx}>
              <label>Số ngày TC</label>
              <br/> <label className={ this.getTC(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"green", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "3_" + idx}  key={"workdayinfo_" + dayOfWeek + "3_" + idx}>
              <label>Số món TC</label>
              <br/> <label className={ this.getTC(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
        </>
      );
    } 

    if (dayOfWeek === 6){
      return (
        <>
          <th style={{ background:"yellow", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "1_" + idx}  key={"workdayinfo_" + dayOfWeek + "1_" + idx}>
              <label>Số ngày cần LV</label>
              <br/> <label>{ this.toFix(this.state.soNgayCanLVInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"yellow", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "2_" + idx}  key={"workdayinfo_" + dayOfWeek + "2_" + idx}>
              <label>Số ngày TC</label>
              <br/> <label className={ this.getTC(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"yellow", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "3_" + idx}  key={"workdayinfo_" + dayOfWeek + "3_" + idx}>
              <label>Số món TC</label>
              <br/> <label className={ this.getTC(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
        </>
      );
    } 

    if (dayOfWeek === 7){
      return (
        <>
          <th style={{ background:"orange", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "1_" + idx}  key={"workdayinfo_" + dayOfWeek + "1_" + idx}>
              <label>Số ngày cần LV</label>
              <br/> <label>{ this.toFix(this.state.soNgayCanLVInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"orange", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "2_" + idx}  key={"workdayinfo_" + dayOfWeek + "2_" + idx}>
              <label>Số ngày TC</label>
              <br/> <label className={ this.getTC(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"orange", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "3_" + idx}  key={"workdayinfo_" + dayOfWeek + "3_" + idx}>
              <label>Số món TC</label>
              <br/> <label className={ this.getTC(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
        </>
      );
    } 

    if (dayOfWeek === 8){
      return (
        <>
          <th style={{ background:"pink", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "1_" + idx}  key={"workdayinfo_" + dayOfWeek + "1_" + idx}>
              <label>Số ngày cần LV</label>
              <br/> <label>{ this.toFix(this.state.soNgayCanLVInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"pink", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "2_" + idx}  key={"workdayinfo_" + dayOfWeek + "2_" + idx}>
              <label>Số ngày TC</label>
              <br/> <label className={ this.getTC(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"pink", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "3_" + idx}  key={"workdayinfo_" + dayOfWeek + "3_" + idx}>
              <label>Số món TC</label>
              <br/> <label className={ this.getTC(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
        </>
      );
    } 
    
    return (
      <>
          <th style={{ background:"white", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "1_" + idx}  key={"workdayinfo_" + dayOfWeek + "1_" + idx}>
              <label>Số ngày cần LV</label>
              <br/> <label>{ this.toFix(this.state.soNgayCanLVInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"white", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "2_" + idx}  key={"workdayinfo_" + dayOfWeek + "2_" + idx}>
              <label>Số ngày TC</label>
              <br/> <label className={ this.getTC(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soNgayTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
          <th style={{ background:"white", textAlign:"center"}} id={"workdayinfo_" + dayOfWeek + "3_" + idx}  key={"workdayinfo_" + dayOfWeek + "3_" + idx}>
              <label>Số món TC</label>
              <br/> <label className={ this.getTC(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }>{ this.toFix(this.state.soMonTCInfo[dayOfWeek + "_" + idx]) }</label>
          </th>
        </>
    );
  }

  toFix(value){
    if (isNaN(value)){
      return value;
    }
    return parseFloat(value).toFixed(2);
  }

  renderDetailsDayOfWeekHeader(dayOfWeek, idx){
    return (
      <>
        <th style={{ background:"gray", textAlign:"center"}} key={"initCapacityByDay" + "1_" + idx}>
            <label>{ "Capacity" }</label>
            <br/>
            <label>{ this.getCapacityByDayOfWeek(dayOfWeek, "initCapacityByDay", idx) }</label>
        </th>
        <th style={{ background:"pink", textAlign:"center"}}  key={"initCapacityByDay" + "2_" + idx}>
            <label>{ "Điều chỉnh" }</label>
            <br/>
            <label>{ this.getCapacityByDayOfWeek(dayOfWeek, "dcCapacityByDay", idx) }</label>
        </th>
        <th style={{ background:"green", textAlign:"center"}}  key={"initCapacityByDay" + "3_" + idx}>
            <label>{ "Thực tế" }</label>
            <br/>
            <label>{ this.getCapacityByDayOfWeek(dayOfWeek, "realCapacityByDay", idx) }</label>
        </th>
      </>
    );
  }

  renderDaysOfWeekForWorker(worker){
    return(
      <>
        { this.state.daysofweek.map((d, idx) => this.renderDayOfWeek(worker, d, idx)) }
      </>
    );
  }

  renderDaysOfWeekForWorkerHeader(){
    return(
      <>
        { this.state.daysofweek.map((d, idx) => this.renderDayOfWeekHeader(d, idx)) }
      </>
    );
  }

  renderWorkDayInfoForWorkerHeader(){
    return(
      <>
        { this.state.daysofweek.map((d, idx) => this.renderWorkDayInfoHeader(d, idx)) }
      </>
    );
  }

  renderDetailsDaysOfWeekForWorkerHeader(){
    return(
      <>
        { this.state.daysofweek.map((d, idx) => this.renderDetailsDayOfWeekHeader(d, idx)) }
      </>
    );
  }

  renderWorkerCapacityRow(worker, index){
    return(
      <tr>
        <td style={{ textAlign: "right"}}>{ index + 1 }&nbsp;</td>
        <td>
          { worker.userName }
          <br/>
          <label style={{ color: "gray"}}>{ this.getCapacityByWorker(worker.userName, "initCapacityByWorker") }</label>,
          <label style={{ color: "pink"}}>{ this.getCapacityByWorker(worker.userName, "dcCapacityByWorker") }</label>,
          <label style={{ color: "green"}}>{ this.getCapacityByWorker(worker.userName, "realCapacityByWorker") }</label>
        </td>
        { this.renderDaysOfWeekForWorker(worker) }
      </tr>
    );
  }

  onReloadWorkers(e){
    this.loadWorkers(false, true);
  }

  renderWorkerCapacityHeader(){
    return(
      <>
        <tr>
          <th style={{ background:"white", textAlign:"center"}} colSpan={ this.state.daysofweek.length * 3 + 2}><label>Capacity</label></th>
        </tr>
        <tr style={{ borderColor: 'brown'}}>
          <th style={{ textAlign: "right"}}>{ "" }</th>
          <th>
            <button className="myButton2" style={{ width: "100%", height: "100%" }}
              onClick={this.onReloadWorkers.bind(this)}>
              <FaFilter color={ICON_COLOR} />
              &nbsp;{couterpart.translate('button_refresh')}
            </button>
          </th>
          { this.renderDaysOfWeekForWorkerHeader() }
        </tr>
        <tr style={{ borderColor: 'brown'}}>
          <th style={{ textAlign: "right"}}>{ "" }</th>
          <th>
            <button className="myButton2" style={{ width: "100%", height: "100%" }}
              onClick={this.handleShowCapcity.bind(this)}>
              <FaEdit color={ICON_COLOR} />
              &nbsp;{couterpart.translate('planning_capacity_button')}
            </button>
          </th>
          { this.renderWorkDayInfoForWorkerHeader() }
        </tr>
        <tr>
          <th style={{ textAlign: "right"}}>{ "#" }</th>
          <th><label>{ "Thợ" }</label></th>
          { this.renderDetailsDaysOfWeekForWorkerHeader() }
        </tr>
      </>
    );
  }

  renderMasterDaysOfWeekForWorkerHeader(){
    return(
      <>
        { this.state.masterDaysofweek.map((d, idx) => this.renderMasterDayOfWeekHeader(d, idx)) }
      </>
    );
  }

  renderMasterWorkerCapacityHeader(){
    return(
      <>
        <tr>
          <th style={{ background:"white", textAlign:"center"}} colSpan={ this.state.masterDaysofweek.length * 3 + 2}><label>Capacity</label></th>
        </tr>
        <tr style={{ borderColor: 'brown'}}>
          <th style={{ textAlign: "right"}}>{ "#" }</th>
          <th><label>{ "Thợ" }</label></th>
          { this.renderMasterDaysOfWeekForWorkerHeader() }
        </tr>
      </>
    );
  }

  renderMasterDetailsDaysOfWeekForWorkerHeader(){
    return(
      <>
        { this.state.masterDaysofweek.map((d, idx) => this.renderMasterDetailsDayOfWeekHeader(d, idx)) }
      </>
    );
  }

  renderMasterDetailsDayOfWeekHeader(dayOfWeek, idx){
    return (
      <>
        <th style={{ background:"gray", textAlign:"center"}} key={"initCapacityByDay" + "1_" + idx}>
            <label>{ "Capacity" }</label>
            <br/>
            <label>{ this.getCapacityByDayOfWeek(dayOfWeek, "initCapacityByDay", idx) }</label>
        </th>
      </>
    );
  }

  handleDonPhatSinhChange(e){
    if (e.target.value === undefined || e.target.value === null || isNaN(e.target.value)){
      return;
    }

    if (e.target.value === ""){
      this.setState({ donPhatSinh: e.target.value }, () => {
      });
      return;
    } 

    let value = parseInt(e.target.value);
    let donNgayMai = this.state.donHomNay + value;
    this.setState({ donNgayMai: donNgayMai, donPhatSinh: value }, () => {
      // console.log(this.state);
      this.recalculate();
      this.calculateCapacityByDaysOfWeek();
    });
  }

  handleSxDeadlineChange(e){
    if (e.target.value === undefined || e.target.value === null || isNaN(e.target.value)){
      return;
    }

    if (e.target.value === ""){
      this.setState({ deadlineSx: e.target.value }, () => {
      });
      return;
    } 

    let value = parseInt(e.target.value);
    this.setState({ deadlineSx: value }, () => {
      this.recalculate();
      this.calculateCapacityByDaysOfWeek();
    });
  }

  initDaysOfWeek(numOfDay){
    let currentDay = this.state.currentDay;

    let daysofweek = [];
    //Today
    daysofweek.push(currentDay);

    if (currentDay === 8){ // Chu nhat
      currentDay = 1; //Thu 2
    }
    //Next day
    let d = currentDay;
    for(let i=0; i< numOfDay; i++){
      d = d + 1;
      daysofweek.push(d);
      if (d === 8){
        d = 1;
      }
    }

    //console.log(daysofweek);
    return daysofweek;
  }

  handleNumOfDayChange(e){
    if (e.target.value === undefined || e.target.value === null || isNaN(e.target.value)){
      return;
    }

    if (e.target.value === ""){
      this.setState({ numOfDay: e.target.value});
      return;
    }
    let numOfDay = e.target.value - 1;
    let daysofweek = this.initDaysOfWeek(numOfDay);
    this.setState({ numOfDay: e.target.value, daysofweek: daysofweek}, () => {
      this.loadWorkers(false, false);
    });
  }


  renderWorkerCapacityTable(){
    return(
      <>
          {this.state.workers !== undefined && this.state.workers.map((worker, index) => this.renderWorkerCapacityRow(worker, index))}
      </>
    );
  }

  renderMasterWorkerCapacityTable(){
    return(
      <>
          {this.state.workers !== undefined && this.state.workers.map((worker, index) => this.renderMasterWorkerCapacityRow(worker, index))}
      </>
    );
  }

  renderMasterWorkerCapacityRow(worker, index){
    return(
      <tr>
        <td style={{ textAlign: "right"}}>{ index + 1 }&nbsp;</td>
        <td>
          { worker.userName }
        </td>
        { this.renderMasterDaysOfWeekForWorker(worker) }
      </tr>
    );
  }

  renderMasterDaysOfWeekForWorker(worker){
    return(
      <>
        { this.state.masterDaysofweek.map((d, idx) => this.renderMasterDayOfWeek(worker, d)) }
      </>
    );
  }

  renderMasterDayOfWeek(worker, dayOfWeek){
    if (this.state.masterCapacityOfWorkers === undefined || this.state.masterCapacityOfWorkers[worker.userName] === undefined){
      return(<></>);
    }
    let capacityOfDay = this.state.masterCapacityOfWorkers[worker.userName]["initCapacity"][dayOfWeek]
    return (
      <>
        <td>
          <input name={worker.userName + "_master_es_" + dayOfWeek} id={worker.userName + "_master_es_" + dayOfWeek} 
              type="text" size="5" style={{ textAlign: "right", width: '100%'}} placeholder="" 
              onChange={this.handleMasterCapacityChange.bind(this, worker.userName, dayOfWeek)}
              defaultValue={ capacityOfDay } />
        </td>
      </>
    );
  }

  handleMasterCapacityChange(userName, dayOfWeek, e){
    var name = e.target.name;
    if (name === undefined){
        return;
    }

    var value = e.target.value;
    if (value === undefined || isNaN(value) || value === null || value === ""){
        return;
    }

    let masterCapacityOfWorkers = this.state.masterCapacityOfWorkers;
    masterCapacityOfWorkers[userName]["initCapacity"][dayOfWeek + ""] = value;
    this.setState({ masterCapacityOfWorkers:  masterCapacityOfWorkers}, () => {
      //console.log(this.state.masterCapacityOfWorkers);
    });
  }

  onSavePlan(e){
    let capacityOfWorkers = this.state.capacityOfWorkers;
    let planInfo = {
      numOfDay: this.state.numOfDay,
      donPhatSinh: this.state.donPhatSinh,
      deadlineSx: this.state.deadlineSx,
      capacityOfWorkers: capacityOfWorkers
    };

    let info = JSON.stringify(planInfo);
    var encodedStringBtoA = btoa(info);
    // var encodedStringBtoA = this.encodeBase64(info);
    console.log(encodedStringBtoA);
    WorkOrderDataService.saveSimplePlan(encodedStringBtoA).then(data => {
      this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
      console.log("SIMPLE PLAN SAVED: ", data);
      alert("Simple plan đã được lưu.");
    });
  }

  handleClose(){
    this.setState({ show: false });
  }

  handleSave(){
    let workers = this.state.workers;
    let workerCapacities = [];
    for(let i =0; i< workers.length; i++){
      let worker = workers[i];
      let capacity = this.state.masterCapacityOfWorkers[worker.userName]["initCapacity"];
      let workerCapacity = {
        userId: worker.key,
        thuHai: capacity["2"],
        thuBa: capacity["3"],
        thuTu: capacity["4"],
        thuNam: capacity["5"],
        thuSau: capacity["6"],
        thuBay: capacity["7"],
        thuTam: capacity["8"]
      };
      workerCapacities.push(workerCapacity);
    }

    UserDataService.saveMasterCapacity(workerCapacities).then(data => {
      if (data > 0){
        alert("Capacity của thợ đã được lưu.");
        this.setState({ show: false });
      }
    });
  }

  handleShowCapcity(){
    this.loadWorkerCapacities();
  }


  render() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService()) {
      return (<div>Unauthorized access.</div>);
    }

    console.log("this.state.numOfDay", this.state.numOfDay);
    return (
      <div>
        <MenuComponent2 />
        <ToastsContainer store={ToastsStore} position="bottom_center" />
        <br />
        <div className="row border-top border-left border-right border-bottom border-light-gray" style={{ margin: '2px' }}>
          <div className="col-12">
            <div className="row">
              <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px' }}>
                <div className="row">
                  <div className="col-2" style={{ whiteSpace: 'nowrap' }}>
                    <label><b>{couterpart.translate('order_date_from')}</b></label>
                  </div>
                  <div className="col-3">
                    <div className="customDatePickerWidth">
                      <DatePicker name="orderDateFrom"
                        dateFormat="MM/dd/yyyy hh:mm"
                        selected={WorkOrderUtil.convertToDate(this.state.fromDate)}
                        onChange={this.handleFromDateChange.bind(this)} />
                    </div>
                  </div>
                  <div className="col-2" style={{ whiteSpace: 'nowrap' }}><label><b>{couterpart.translate('order_date_to')}</b></label></div>
                  <div className="col-3">
                    <div className="customDatePickerWidth">
                      <DatePicker name="orderDateTo"
                        dateFormat="MM/dd/yyyy hh:mm"
                        selected={WorkOrderUtil.convertToDate(this.state.toDate)}
                        onChange={this.handleToDateChange.bind(this)} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px' }}>
                <div className="row">
                  <div className="col-10" style={{ whiteSpace: 'nowrap' }}>
                    <label><b>{couterpart.translate('planning_num_of_day')} ({ this.getDate() })</b></label>
                  </div>
                  <div className="col-2">
                    <input type="text" defaultValue={this.state.numOfDay} style={{ width: '100%' }}
                      onChange={this.handleNumOfDayChange.bind(this)}/>
                  </div>
                </div>
              </div>
            </div>
            <div className="row ">
              <div className="col-12" style={{ padding: '5px', marginRight: '5px' }}>
                <div className="row">
                  <div className="col-12" style={{ width: "100%", marginTop: "5px" }}><label><b>{couterpart.translate('work_orders')}</b></label>
                    <div className="row">
                      <div className="col-11">
                        <Multiselect style={{ width: "100%" }}
                          options={this.state.statusList}
                          selectedValues={this.state.selectedWoStatusList}
                          onSelect={this.onStatusSelect.bind(this)}
                          onRemove={this.onStatusRemove.bind(this)}
                          displayValue="name"
                          showCheckbox={true}
                        />
                      </div>
                      <div className="col-1" style={{ paddingLeft: '10px', paddingRight: '0px' }}>
                        <button className="myButton2" style={{ width: "50%" }}
                          onClick={this.onFilter.bind(this)}>
                          <FaFilter color={ICON_COLOR} />
                          &nbsp;{couterpart.translate('button_filter')}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>  
          </div>
        </div>
        <div className="row border-top border-left border-right border-bottom border-light-gray" style={{ margin: '2px' }}>
          <div className='col-12'>
            <button className="myButton2" style={{ width: "100%", height: "100%" }}
              onClick={this.onSavePlan.bind(this)}>
              <FaSave color={ICON_COLOR} />
              &nbsp;{couterpart.translate('button_save')}
            </button>
          </div>
        </div>
        <div className="row border-top border-left border-right border-bottom border-light-gray" style={{ margin: '2px' }}>
          <div className='col-12'>
            <table border="1" cellPadding="5" cellPadding="5" width="100%">
              <tbody>
              <tr>
                <th style={{ background:"orange"}}><label>Đơn đầungày (8am)</label></th>
                <th style={{ background:"orange"}}><label>Đơn hôm nay</label></th>
                <th style={{ background:"orange"}}><label>Đơn upload hôm nay (00:00:00 => 23:59:59)</label></th>
                <th style={{ background:"lightgreen"}}><label>Đơn phát sinh - ngày hôm nay</label></th>
                <th style={{ background:"orange"}}><label>Số giờ đã làm</label> - Số món đã làm</th>
                <th style={{ background:"orange"}}><label>Đơn ngày các ngày kế tiếp</label></th>
                <th style={{ background:"lightgreen"}}><label>Deadline SX</label></th>
              </tr>
              <tr>
                <td  style={{ textAlign: "center"}}>&nbsp;<label>{ this.state.donDauNgay }</label></td>
                <td  style={{ textAlign: "center"}}>&nbsp;<label>{ this.state.donHomNay }</label></td>
                <td  style={{ textAlign: "center"}}>&nbsp;<label>{ this.state.don24 }</label></td>
                <td>
                  <input type="text" style={{ width: '100%' }} value = {this.state.donPhatSinh} size="5"
                      onChange={this.handleDonPhatSinhChange.bind(this)}/>
                </td>
                <td><label style={{ background: "white"}}>{ this.getNumOfWorkedHours() }</label> => <label style={{ background: "white"}}> { this.getSoMonDaLam(this.state.daysofweek[0], 0) } </label></td>
                <td  style={{ textAlign: "center"}}>&nbsp;<label>{ this.state.donNgayMai - this.getSoMonDaLam(this.state.daysofweek[0], 0) }</label></td>
                <td style={{width: "7%"}}>
                  <input type="text" defaultValue={ this.state.deadlineSx } style={{ width: '100%' }}
                      onChange={this.handleSxDeadlineChange.bind(this)}/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="row border-top border-left border-right border-bottom border-light-gray" style={{ margin: '2px' }}>
          <div className='col-12'>
            <table border="1" cellPadding={5} cellPadding={5} width={"100%"} style={{ display: "block", overflow: "scroll", whiteSpace: "nowrap"}}>
              <thead>
              { this.renderWorkerCapacityHeader() }
              </thead>
              <tbody>
              { this.renderWorkerCapacityTable() }
              </tbody>
            </table>
          </div>
        </div>

        <Modal show={this.state.show} onHide={this.handleClose.bind(this)} backdrop="static"  dialogClassName='modal-60w'>
            <Modal.Header closeButton style={{ background: 'lightblue'}}>
                <Modal.Title>{ "CẬP NHẬT CAPACITY CỦA THỢ" }</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row border-top border-left border-right border-bottom border-light-gray" style={{ margin: '2px' }}>
                <div className='col-12'>
                  <table border="1" cellPadding={5} cellPadding={5} width={"100%"}>
                    <thead>
                    { this.renderMasterWorkerCapacityHeader() }
                    </thead>
                    <tbody>
                    { this.renderMasterWorkerCapacityTable() }
                    </tbody>
                  </table>
                </div>
              </div>                    
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={this.handleClose.bind(this)}>Cancel</Button>
              <Button variant="primary" onClick={ this.handleSave.bind(this) }>OK</Button>  
            </Modal.Footer>
        </Modal>
        <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
        <Dialog ref={(component) => { this.dialog = component }} />
      </div>
    )
  }
}
export default withRouter(PlanningSimple);